import Vue from 'vue'
import VueRouter from 'vue-router'
/**
 * 重写路由的push方法
 */
const routerPush = VueRouter.prototype.push
VueRouter.prototype.push = function push(location) {
    return routerPush.call(this, location).catch(error => error)
}

Vue.use(VueRouter)

const routes = [
    {
        path: "/login",
        name: "login",
        component: () =>
            import ("@/views/login"),
    },
    {
        path: "/",
        component: () =>
            import ("@/layar"),
        children: [
          {
            path: "/userList",
            name: "userList",
            component: () =>
                import ("@/views/userList"),
          },
          {
            path: "/userShow",
            name: "userShow",
            component: () =>
                import ("@/views/userList/userShow"),
          },
          {
            path: "/roleList",
            name: "roleList",
            component: () =>
                import ("@/views/roleList/roleList"),
          },
          {
            path: "/permissionAssign",
            name: "permissionAssign",
            component: () =>
                import ("@/views/permissionAssign/permissionAssign"),
          },
          {
            path: "/accountList",
            name: "accountList",
            component: () =>
                import ("@/views/accountList/accountList"),
          },
          {
            path: "/minercodelist",
            name: "minercodelist",
            component: () =>
                import ("@/views/minercodeage/minercodelist"),
          },
          {
            path: "/nodeListView",
            name: "nodeListView",
            component: () =>
                import ("@/views/minercodeage/nodeListView"),
          },
          {
            path: "/centsAuditNew",
            name: "centsAuditNew",
            component: () =>
                import ("@/views/minercodeage/centsAuditNew"),
          },
          {
            path: "/productList",
            name: "productList",
            component: () =>
                import ("@/views/product/productList"),
          },
          {
            path: "/currencyList",
            name: "currencyList",
            component: () =>
                import ("@/views/walletMessgae/currencyList"),
          },

          {
            path: "/chargeMoney",
            name: "chargeMoney",
            component: () =>
                import ("@/views/walletMessgae/chargeMoney"),
          },
          {
            path: "/walletWithdrawalApply",
            name: "walletWithdrawalApply",
            component: () =>
                import ("@/views/walletMessgae/walletWithdrawalApply"),
          },
          {
            path: "/walletWithdrawalList",
            name: "walletWithdrawalList",
            component: () =>
                import ("@/views/walletMessgae/walletWithdrawalList"),
          },
          {
            path: "/ditchList",
            name: "ditchList",
            component: () =>
                import ("@/views/ditchMessage/ditchList"),
          },
          {
            path: "/copyCenterList",
            name: "copyCenterList",
            component: () =>
                import ("@/views/copyCenter/copyCenterList"),
          },
          {
            path: "/copyAdd",
            name: "copyAdd",
            component: () =>
                import ("@/views/copyCenter/copyAdd"),
          },
          {
            path: "/copyTypeList",
            name: "copyTypeList",
            component: () =>
                import ("@/views/copyCenter/copyTypeList"),
          },
          {
            path: "/orderList",
            name: "orderList",
            component: () =>
                import ("@/views/orderList/orderList"),
          },
          {
            path: "/orderRenewalPledgeGas",
            name: "orderRenewalPledgeGas",
            component: () =>
                import ("@/views/orderList/orderRenewalPledgeGas"),
          },
          {
            path: "/orderCheckList",
            name: "orderCheckList",
            component: () =>
                import ("@/views/orderList/orderCheckList"),
          },
          {
            path: "/artificialList",
            name: "artificialList",
            component: () =>
                import ("@/views/orderList/artificialList"),
          },
          {
            path: "/artificialListTwo",
            name: "artificialListTwo",
            component: () =>
                import ("@/views/orderList/artificialListTwo"),
          },
          {
            path: "/auditOrderList",
            name: "auditOrderList",
            component: () =>
                import ("@/views/orderList/auditOrderList"),
          },
          {
            path: "/unpaidOrderCheckList",
            name: "unpaidOrderCheckList",
            component: () =>
                import ("@/views/orderList/unpaidOrderCheckList"),
          },
          {
            path: "/ourCatalogueList",
            name: "ourCatalogueList",
            component: () =>
                import ("@/views/orderList/ourCatalogueList"),
          },
          {
            path: "/certificationList",
            name: "certificationList",
            component: () =>
                import ("@/views/certification/certificationList"),
          },
          {
            path: "/orderIncomeDaily",
            name: "orderIncomeDaily",
            component: () =>
                import ("@/views/finance/orderIncomeDaily"),
          },
          {
            path: "/orderCollectDetail",
            name: "orderCollectDetail",
            component: () =>
                import ("@/views/finance/orderCollectDetail"),
          },
          {
            path: "/nodeIncomeExpenditure",
            name: "nodeIncomeExpenditure",
            component: () =>
                import ("@/views/finance/nodeIncomeExpenditure"),
          },
          {
            path: "/nodeIncomeExpenditureDaily",
            name: "nodeIncomeExpenditureDaily",
            component: () =>
                import ("@/views/finance/nodeIncomeExpenditureDaily"),
          },
          {
            path: "/nodeProductAccount",
            name: "nodeProductAccount",
            component: () =>
                import ("@/views/finance/nodeProductAccount"),
          },
          {
            path: "/netPowerDaily",
            name: "netPowerDaily",
            component: () =>
                import ("@/views/finance/netPowerDaily"),
          },
          {
            path: "/filBalanceStatistics",
            name: "filBalanceStatistics",
            component: () =>
                import ("@/views/finance/filBalanceStatistics"),
          },
          {
            path: "/pledgeFilBalanceDetail",
            name: "pledgeFilBalanceDetail",
            component: () =>
                import ("@/views/finance/pledgeFilBalanceDetail"),
          },
          {
            path: "/frozenFilBalanceDetail",
            name: "frozenFilBalanceDetail",
            component: () =>
                import ("@/views/finance/frozenFilBalanceDetail"),
          },
          {
            path: "/availableUsdtBalanceDetail",
            name: "availableUsdtBalanceDetail",
            component: () =>
                import ("@/views/finance/availableUsdtBalanceDetail"),
          },
          {
            path: "/availableFilBalanceDetail",
            name: "availableFilBalanceDetail",
            component: () =>
                import ("@/views/finance/availableFilBalanceDetail"),
          },
          {
            path: "/filBalanceSummary",
            name: "filBalanceSummary",
            component: () =>
                import ("@/views/finance/filBalanceSummary"),
          },
          {
            path: "/companyIncomeDaily",
            name: "companyIncomeDaily",
            component: () =>
                import ("@/views/finance/companyIncomeDaily"),
          },
          {
            path: "/trusIncomeDaily",
            name: "trusIncomeDaily",
            component: () =>
                import ("@/views/finance/trusIncomeDaily"),
          },
          {
            path: "/allCompanyIncomeDaily",
            name: "allCompanyIncomeDaily",
            component: () =>
                import ("@/views/finance/allCompanyIncomeDaily"),
          },
          {
            path: "/pledgeGasDaily",
            name: "pledgeGasDaily",
            component: () =>
                import ("@/views/finance/pledgeGasDaily"),
          },
          {
            path: "/coinPriceDaily",
            name: "coinPriceDaily",
            component: () =>
                import ("@/views/finance/coinPriceDaily"),
          },
          {
            path: "/diffAllocDaily",
            name: "diffAllocDaily",
            component: () =>
                import ("@/views/finance/diffAllocDaily"),
          },
          {
            path: "/salesStatisticsDetail",
            name: "salesStatisticsDetail",
            component: () =>
                import ("@/views/finance/salesStatisticsDetail"),
          },
          {
            path: "/salesStatisticsSummary",
            name: "salesStatisticsSummary",
            component: () =>
                import ("@/views/finance/salesStatisticsSummary"),
          },
          {
            path: "/userBalanceChange",
            name: "userBalanceChange",
            component: () =>
                import ("@/views/finance/userBalanceChange"),
          },
          {
            path: "/nodePoolList",
            name: "nodePoolList",
            component: () =>
                import ("@/views/nodePool/nodePoolList"),
          },
          {
            path: "/nodePoolIncome",
            name: "nodePoolIncome",
            component: () =>
                import ("@/views/nodePool/nodePoolIncome"),
          },
          {
            path: "/nodePoolAllocate",
            name: "nodePoolAllocate",
            component: () =>
                import ("@/views/nodePool/nodePoolAllocate"),
          },
          {
            path: "/centList",
            name: "centList",
            component: () =>
                import ("@/views/nodePool/centList"),
          },
          {
            path: "/opList",
            name: "opList",
            component: () =>
                import ("@/views/agencyManage/opList"),
          },
          {
            path: "/agentList",
            name: "agentList",
            component: () =>
                import ("@/views/agencyManage/agentList"),
          },
          {
            path: "/agentStatistics",
            name: "agentStatistics",
            component: () =>
                import ("@/views/agencyManage/agentStatistics"),
          },
          {
            path: "/agentStatisticsHistory",
            name: "agentStatisticsHistory",
            component: () =>
                import ("@/views/agencyManage/agentStatisticsHistory"),
          },
          {
            path: "/couponList",
            name: "couponList",
            component: () =>
                import ("@/views/couponManage/couponList"),
          },
          {
            path: "/addEidt",
            name: "addEidt",
            component: () =>
                import ("@/views/couponManage/addEidt"),
          },
          {
            path: "/couponExamine",
            name: "couponExamine",
            component: () =>
                import ("@/views/couponManage/couponExamine"),
          },
          {
            path: "/cooperationManage",
            name: "cooperationManage",
            component: () =>
                import ("@/views/cooperationManage/index"),
          },
        ],
    },
    {
        path: "*",
        redirect: "/404",
    },
];
const router = new VueRouter({
    mode: 'history',
    base: process.env.BASE_URL,
    routes
})



router.beforeEach((to, from, next) => {
    let user = JSON.parse(sessionStorage.getItem('userToken'))
    if (to.name == 'login' || user) {
        console.log(1)
        if (to.matched.length === 0) {
            from.name ? next({ name: from.name }) : next('/');
        } else {
            next();
        }
    } else {
        // next()
        next({ name: 'login' })
    }
})

export default router